import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  role: string;
  image: string;
  stars: number;
}
const testimonials: Testimonial[] = [{
  quote: 'No sé cómo explicarlo, pero desde que empecé… algo cambió en mí. La ansiedad que me acompañaba durante años se ha reducido drásticamente.',
  name: 'Mariana Torres',
  role: 'Emprendedora',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  stars: 5
}, {
  quote: 'Llevaba años buscando algo que realmente funcionara. Este programa me dio las herramientas que necesitaba para encontrar paz mental.',
  name: 'Carlos Mendoza',
  role: 'Profesional de Marketing',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  stars: 5
}, {
  quote: 'Las técnicas de meditación que aprendí me ayudaron a manejar el estrés laboral y mejorar mi concentración. Recomendaría este programa a cualquiera.',
  name: 'Laura Sánchez',
  role: 'Docente',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  stars: 4
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-purple-50" data-id="element-333">
      <div className="container mx-auto px-4" data-id="element-334">
        <div className="max-w-5xl mx-auto" data-id="element-335">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-purple-800" data-id="element-336">
            Testimonios de Alumnos
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-337">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-lg relative flex flex-col h-full" data-id="element-338">
                <div className="absolute -top-6 left-6 text-purple-500" data-id="element-339">
                  <QuoteIcon size={36} data-id="element-340" />
                </div>
                <div className="pt-6 flex-grow" data-id="element-341">
                  <p className="text-lg italic text-gray-700 mb-6" data-id="element-342">
                    "{testimonial.quote}"
                  </p>
                  <div className="flex items-center mt-auto" data-id="element-343">
                    <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-purple-200" data-id="element-344" />
                    <div data-id="element-345">
                      <p className="font-medium text-gray-900" data-id="element-346">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-gray-500" data-id="element-347">
                        {testimonial.role}
                      </p>
                      <div className="flex mt-1" data-id="element-348">
                        {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} className={i < testimonial.stars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} data-id="element-349" />)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
          <div className="mt-16 text-center text-lg text-gray-700" data-id="element-350">
            <p data-id="element-351">
              He visto esta transformación en alumnos, emprendedores y líderes
              que pasaron de ansiedad y vacío a vivir con paz, enfoque y
              propósito.
            </p>
            <p className="mt-4 font-medium text-purple-800 text-xl" data-id="element-352">
              Ahora es tu turno.
            </p>
          </div>
        </div>
      </div>
    </section>;
}